import { z } from "zod"

import { CapabilityExecutionStatus, CapabilityIdentifier } from "../../capabilities/dtos"
import {
  BackofficeCapabilityExecutionActionEnum,
  BackofficeCapabilityExecutionProviderEnum,
} from "./dtos"

export const BackofficeCapabilityExecutionKpiResponseDataSchema = z.object({
  total: z.number(),
  success: z.number(),
  unsuccess: z.number(),
  cached: z.number(),
  error: z.number(),
  skipped: z.number(),
})

export const BackofficeSelectedCapabilityMetricsResponseDataSchema = z.object({
  turnsToSuccess: z.number().nullable(),
  successRate: z.number(),
  successfulConversations: z.number().int(),
  totalConversations: z.number().int(),
})

export const BackofficeCapabilityExecutionTimeSeriesPointResponseDataSchema = z.object({
  date: z.string(),
  status: z.enum(CapabilityExecutionStatus),
  count: z.number(),
})

export const BackofficeCapabilityExecutionDistributionItemResponseDataSchema = z.object({
  capabilityIdentifier: z.enum(CapabilityIdentifier),
  count: z.number(),
})

export const BackofficeCapabilityExecutionActionDistributionItemResponseDataSchema = z.object({
  action: z.enum(BackofficeCapabilityExecutionActionEnum),
  count: z.number(),
})

export const BackofficeCapabilityExecutionReasonDistributionItemResponseDataSchema = z.object({
  reason: z.string(),
  count: z.number(),
})

export const BackofficeCapabilityExecutionRowResponseDataSchema = z.object({
  blockedByCapabilityIdentifier: z.enum(CapabilityIdentifier).nullable(),
  technicalExecutions: z.array(
    z.object({
      id: z.string(),
      capabilityIdentifier: z.enum(CapabilityIdentifier),
      status: z.enum(CapabilityExecutionStatus),
      reason: z.string().nullable(),
    }),
  ),
  id: z.string(),
  executionCount: z.number(),
  customerId: z.string(),
  customerName: z.string().nullable(),
  organizationId: z.string(),
  companyName: z.string(),
  companyLogo: z.string().nullable(),
  conversationId: z.string(),
  capabilityId: z.string(),
  capabilityIdentifier: z.string(),
  capabilityName: z.string().nullable(),
  action: z.enum(BackofficeCapabilityExecutionActionEnum).nullable(),
  provider: z.enum(BackofficeCapabilityExecutionProviderEnum).nullable(),
  status: z.enum(CapabilityExecutionStatus),
  reason: z.string().nullable(),
  createdAt: z.date().transform((value) => value.toISOString()),
})

export const BackofficeCapabilityExecutionsAnalyticsResponseDataSchema = z.object({
  kpis: BackofficeCapabilityExecutionKpiResponseDataSchema,
  selectedCapabilityMetrics: BackofficeSelectedCapabilityMetricsResponseDataSchema.nullable(),
  timeSeries: z.array(BackofficeCapabilityExecutionTimeSeriesPointResponseDataSchema),
  capabilityDistribution: z.array(BackofficeCapabilityExecutionDistributionItemResponseDataSchema),
  actionDistribution: z.array(
    BackofficeCapabilityExecutionActionDistributionItemResponseDataSchema,
  ),
  reasonDistribution: z.array(
    BackofficeCapabilityExecutionReasonDistributionItemResponseDataSchema,
  ),
  rowCount: z.number(),
  rows: z.array(BackofficeCapabilityExecutionRowResponseDataSchema),
})
